import { ORGANIZATION_HIERARCHY, ROLES } from 'constants/enums'
import { getActiveRole, getActiveOrganization } from 'utils/token'

/**
 * @param {string} user - user object
 * @param {string} hierarchyType - hierarchyType value
 * @returns {[isLicenseeNameVisible, isReadOnly]}
 */
export const getBillingAddressFormStatus = (user, hierarchyType) => {
  const org = getActiveOrganization(user)
  const userRole = getActiveRole(org)

  // Is NAO or IAC
  const isLicenseeNameVisible = [
    ORGANIZATION_HIERARCHY.NAO.value,
    ORGANIZATION_HIERARCHY.IAC.value,
  ].includes(hierarchyType)

  const isReadOnly =
    isLicenseeNameVisible &&
    ![ROLES.GBT.u, ROLES.IF_STAFF_SUPER.u, ROLES.IF_REGION.u].includes(userRole)

  return [isLicenseeNameVisible, isReadOnly]
}
